<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card card-default">
                <service-wizard-layout
                    title=""
                    subtitle=""
                    :parts="parts"
                    :onComplete="onComplete"
                    :validateStep="validateStep"
                >
                    <template slot="domain">
                        <form novalidate data-vv-scope="domain">
                            <div class="row">
                                <div class="col-xl-8 col-lg-12">
                                    <div class="form-group">
                                        <label>Domain</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            v-model="filledInSaleDefinition.requiredObjs.domain.domainName"
                                        >
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                    <template slot="website">
                        <form novalidate data-vv-scope="website">
                            <div class="row">
                                    <div class="col-xl-8 col-lg-12">
                                        <div class="form-group">
                                            <label>Name of website</label>
                                            <input 
                                                type="text" 
                                                class="form-control"  
                                                v-model="filledInSaleDefinition.requiredObjs.website.websiteName"
                                            >
                                        </div>
                                    </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-8 col-lg-12">
                                    <div class="form-group">
                                        <label>Package</label>
                                        <v-select
                                            name="webHostingPackageNumber"
                                            placeholder="Select Package"
                                            :value="packageLabel"
                                            :options="packageOptions"
                                            @input="changePackage"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </service-wizard-layout>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceWizardLayout from '@/layouts/ServiceWizardLayout';
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
    components: {
        ServiceWizardLayout
    },
    props: {
        emptySaleDefinition: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            parts: [
                {
                    name: "domain",
                    displayName: "Domain",
                    icon: "fa-solid fa-at",
                },
                {
                    name: "website",
                    displayName: "Website",
                    icon: "fa-solid fa-globe",
                },
            ],
            filledInSaleDefinition: {
                requiredObjs: {
                    domain: {},
                    website: {},
                }
            },
            packageOptions: [],
            packageLabel: '',
        }
    },
    mounted() {
        this.filledInSaleDefinition = this.emptySaleDefinition;
                
        for (let i = 0; i < this.filledInSaleDefinition.selectableOptions.webHostingPackage.length; i++) {
            if (this.filledInSaleDefinition.selectableOptions.webHostingPackage.length > 0 && i == 0) {
                this.packageLabel = this.filledInSaleDefinition.selectableOptions.webHostingPackage[i].description;
                this.filledInSaleDefinition.requiredObjs.website.webHostingPackageNumber = this.filledInSaleDefinition.selectableOptions.webHostingPackage[i].webHostingPackageNumber;
            }
            this.packageOptions[i] = this.filledInSaleDefinition.selectableOptions.webHostingPackage[i].description
        }
        
    },
    methods: {
        onComplete() {
            this.$emit("createSale", this.filledInSaleDefinition);
        },
        changePackage(value) {
            for (let i = 0; i < this.filledInSaleDefinition.selectableOptions.webHostingPackage.length; i++) {
                if (value == this.filledInSaleDefinition.selectableOptions.webHostingPackage[i].description) {
                    this.filledInSaleDefinition.requiredObjs.website.webHostingPackageNumber = this.filledInSaleDefinition.selectableOptions.webHostingPackage[i].webHostingPackageNumber;
                }  
            }
        },
        validateStep(scope) {
            return this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>